// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qk-g","icon":"styles_icon__1N2Cc"};